import React, { useState } from "react";
import styles from "./ActiveDialogWFContainer.module.scss";
import { useDispatch, useSelector } from "react-redux";
import ScreenHeader from "../ScreenHeader/ScreenHeader";
import Input from "../../ui/Input/Input";
import Chip from "../../ui/Chip/Chip";
import Switcher from "../../ui/Switcher/Switcher";
import Button from "../../ui/Button/Button";
import { ClipboardIcon } from "../../assets/icons/ClipboardIcon";
import {
  setUpdateAssistantWF,
  setUpdateAssistantWFData,
} from "../../store/slices/asistantWFSlice";
import {
  updateAssistantForm,
  updateAssistantFormStatus,
} from "../../utils/api/actions/integrations/assistantForm";

export const ActiveDialogWFContainer = () => {
  const dispatch = useDispatch();

  const { dataAssistants } = useSelector((state) => state?.assistant);
  const { activeAssistantWF, updateAssistantWF, updateAssistantWFData } =
    useSelector((state) => state?.assistantWF);

  const widgetBlocked = activeAssistantWF?.blocked;
  const widgetActive = activeAssistantWF?.active;
  const widgetCode = activeAssistantWF.code;

  const [isSwitchOn, setIsSwitchOn] = useState(widgetActive);
  const [copied, setCopied] = useState(false);
  const [loading, setLoading] = useState(false);

  const isEmptyObject = (obj) =>
    !!obj && typeof obj === "object" && Object.keys(obj).length > 0;

  const assistantName =
    dataAssistants?.find(
      (assistant) => assistant.id === activeAssistantWF?.assistantId
    )?.name || "Ассистент не найден";

  const initialData = {
    assistantFormId: activeAssistantWF.id,
    allowedDomains: activeAssistantWF.allowedDomains,
  };

  const handleToggle = () => {
    const newStatus = !isSwitchOn;
    const data = {
      assistantFormId: activeAssistantWF.id,
      active: newStatus,
    };
    setIsSwitchOn(newStatus);
    dispatch(updateAssistantFormStatus(data));
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(activeAssistantWF.code).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Сообщение о копировании исчезает через 2 секунды
    });
  };

  const handleFocusInput = () => {
    dispatch(setUpdateAssistantWF(true));
  };

  const handlerInput = (e) => {
    if (updateAssistantWF) {
      let res = JSON.parse(JSON.stringify(updateAssistantWFData));

      Object.defineProperty(res, e.target.name, {
        value: e.target.value,
        writable: true,
        enumerable: true,
        configurable: true,
      });

      res.assistantFormId = activeAssistantWF?.id;

      dispatch(setUpdateAssistantWFData(res));
    }
  };

  const handleCancelEdit = () => {
    dispatch(setUpdateAssistantWFData(initialData));
    dispatch(setUpdateAssistantWF(false));
  };

  const handleSaveUpdatedData = () => {
    dispatch(updateAssistantForm(updateAssistantWFData, setLoading));
  };

  return (
    <div>
      <ScreenHeader
        path={"/integration"}
        title={"Интеграции"}
        onCancelEdit={handleCancelEdit}
        onSaveUpdatedData={handleSaveUpdatedData}
        isEditing={updateAssistantWF}
        loading={loading}
      />
      <div className={styles.widgetPageContainer}>
        <div className={styles.headerWidget}>
          <div className={styles.titleContainer}>
            <div className={styles.inputContainer}>
              <Input
                className={styles.child}
                label="Название"
                labelStyle={styles.labelInput}
                backgroundStyle={styles.labelBackground}
                inputStyle={styles.input}
                name="name"
                value={activeAssistantWF ? activeAssistantWF.name : ""}
                readOnly={true}
                type={"text"}
              />
            </div>
            <div className={styles.inputContainer}>
              <Input
                className={styles.child}
                label="Ассистент"
                labelStyle={styles.labelInput}
                backgroundStyle={styles.labelBackground}
                inputStyle={styles.input}
                name="assistant"
                value={activeAssistantWF ? assistantName : ""}
                readOnly={true}
                type={"text"}
              />
            </div>
            <div className={styles.inputContainer}>
              <Input
                className={styles.child}
                label="Доверенные домены"
                labelStyle={styles.labelInput}
                backgroundStyle={styles.labelBackground}
                inputStyle={styles.input}
                name="allowedDomains"
                onFocus={handleFocusInput}
                value={
                  isEmptyObject(updateAssistantWFData)
                    ? updateAssistantWFData.allowedDomains
                    : activeAssistantWF
                    ? activeAssistantWF.allowedDomains
                    : ""
                }
                onChange={handlerInput}
                type={"text"}
              />
            </div>
          </div>

          <div className={styles.statusContainer}>
            <Chip
              classNameChip={styles.widgetChipContainer}
              active={widgetActive}
              classNameChipActive={styles.widgetChipContainerActive}
              classNameChipDisabled={styles.widgetChipContainerDisabled}
              title={widgetActive ? "Активен" : "Не активен"}
            />
            <Switcher bool={isSwitchOn} onToggle={handleToggle} />
            {widgetBlocked && (
              <Chip
                active={widgetBlocked}
                title={widgetBlocked ? "Заблокирован" : "Не заблокирован"}
              />
            )}
          </div>
        </div>

        {activeAssistantWF.code ? (
          <div className={styles["code-block"]}>
            <div className={styles.buttonContainer}>
              <Button
                leftIcon={
                  <ClipboardIcon width={16} height={20} fill={"white"} />
                }
                onClick={handleCopy}
                titleClassName={styles.copyButtonTitle}
                className={`${styles["copy-button"]} ${
                  copied ? styles.copied : ""
                }`}
                title={copied ? "Код скопирован!" : "Скопировать код"}
              />
            </div>

            <pre>{widgetCode}</pre>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};
